@if (linkCard?.media) {
  <sd-banner
    [media]="linkCard?.media"
    [isFit]="isFit"
    [imgRatio]="imageRatioEnum.r16_9"
  />
}

@if (linkCard?.link && linkCard?.link?.linkName) {
  <sd-title customClass="brand--h5" [titleLevel]="titleLevel">
    {{linkCard.link.linkName}}
  </sd-title>
}

@if (linkCard?.link) {
  <sd-link
    customClass="is-full-area"
    (clicked)="onClick()"
    [link]="linkCard?.link"
  >
    @if (linkCard.link?.linkName) {
      <span class="is-visually-hidden">
        {{linkCard.link.linkName}}
      </span>
    }
  </sd-link>
}
